export default __webpack_public_path__ + "static/media/saintefamille.cc1d187e.png";